import "./webcam-map.scss"
import { BaseComponent } from "utils/base-component"
import type { AdminWebcamMapConfig } from "./map"

export class AdminWebcamMap extends BaseComponent<AdminWebcamMapConfig[]> {
  static cssClass = "admin-webcam-map"

  init() {
    const mapIdStr = this.root.dataset.mapId
    if (mapIdStr === undefined) return

    const mapId = parseInt(mapIdStr, 10)
    if (this.config[mapId] === undefined) return

    import(/* webpackChunkName: 'admin-webcam-map' */ "./map").then((module) => {
      const WebcamMapModule = module.default
      // eslint-disable-next-line no-new
      new WebcamMapModule(this.root, this.config[mapId])
    })
  }
}
